import React, { useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import ContractCard from 'features/organizations/organizationTabsContent/ContractCard';
import { organizationActions } from 'actions/organizationActions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import PageSpinner from 'components/spinners/PageSpinner';
import { ApplicationState } from 'store';

const useStyles = makeStyles(() => ({
  container: {
    margin: 0,
    maxWidth: '100%',
  },
}));

const ContractTab: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { orgId } = useParams<{ orgId: string }>();

  const { currentContract, nextContract } = useSelector(
    (state: ApplicationState) => ({
      currentContract: state.organization?.currentContract,
      nextContract: state.organization?.nextContract,
    }),
  );

  useEffect(() => {
    if (orgId) {
      dispatch(organizationActions.getCurrentContract(orgId));
      dispatch(organizationActions.getNextContract(orgId));
    }
  }, [orgId]);

  return (
    <PageSpinner
      isLoading={currentContract === undefined || nextContract === undefined}
    >
      <Grid container spacing={2} direction="row" className={classes.container}>
        <Grid item xs={12}>
          <ContractCard />
        </Grid>
        <Grid item xs={12}>
          <ContractCard isNextContract />
        </Grid>
      </Grid>
    </PageSpinner>
  );
};

export { ContractTab };
